import { WECOM_CORP_ID } from "@/config/constants";

export default function getQywxCorpId() {
  return localStorage.getItem(WECOM_CORP_ID);
}
